export const isShown = (modes, hideModes, value) => {
  if (value === "insurance") return hideModes === undefined || !hideModes.includes(value);
  if (value === "stayLodging") return hideModes === undefined || !hideModes.includes(value);
  return (modes === undefined || modes.includes(value)) && (hideModes === undefined || !hideModes.includes(value));
};
export const getQueryStringValue = key => {
  return decodeURIComponent(window.location.search.replace(new RegExp("^(?:.*[&\\?]" + encodeURIComponent(key).replace(/[.+*]/g, "\\$&") + "(?:\\=([^&]*))?)?.*$", "i"), "$1"));
};
export const createGMTDate = _date => {
  const date = _date === undefined ? new Date() : new Date(_date);
  const day = date.getDate();
  const month = date.getMonth();
  const year = date.getFullYear();
  date.setMinutes(date.getMinutes() + date.getTimezoneOffset());
  date.setHours(0);
  const newDay = date.getDate();
  const newMonth = date.getMonth();
  const newYear = date.getFullYear();
  if (date.getTimezoneOffset() < 0 && (newDay < day || newMonth < month || newYear < year)) {
    date.setDate(date.getDate() + 1);
  }
  return date;
};
export const isMobileDevice = () => {
  if (navigator.userAgent.match(/Android/i) || navigator.userAgent.match(/webOS/i) || navigator.userAgent.match(/iPhone/i) || navigator.userAgent.match(/iPad/i) || navigator.userAgent.match(/iPod/i) || navigator.userAgent.match(/BlackBerry/i) || navigator.userAgent.match(/Windows Phone/i)) {
    return true;
  }
  return false;
};